
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("al4VD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $6f0Oj = parcelRequire("6f0Oj");


var $bUlM5 = parcelRequire("bUlM5");


var $ecnYn = parcelRequire("ecnYn");


var $dAYOx = parcelRequire("dAYOx");


var $c4sKh = parcelRequire("c4sKh");


var $1lhEF = parcelRequire("1lhEF");


var $2Fndw = parcelRequire("2Fndw");


var $9wGTI = parcelRequire("9wGTI");


var $a90ar = parcelRequire("a90ar");


var $k7Tf7 = parcelRequire("k7Tf7");

function $97c789ddabfb1332$var$_defineProperty(e, r, t) {
    return (r = $97c789ddabfb1332$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $97c789ddabfb1332$var$_toPropertyKey(t) {
    var i = $97c789ddabfb1332$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $97c789ddabfb1332$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97c789ddabfb1332$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $97c789ddabfb1332$var$labelContainerStyles = (0, $ecnYn.xcss)({
    flex: 2
});
const $97c789ddabfb1332$var$badgeContainerStyles = (0, $ecnYn.xcss)({
    paddingLeft: 'space.075'
});
class $97c789ddabfb1332$var$ContentToolsItemClass extends (0, $42omo.PureComponent) {
    render() {
        const { label: label, onClick: onClick, url: url, id: id, className: className, isDisabled: isDisabled, innerRef: innerRef, testId: testId, onMouseEnter: onMouseEnter, shouldHighlight: shouldHighlight, elemBefore: elemBefore, interactionName: interactionName } = this.props;
        const contentToolsItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onMouseEnter,
            onFocus: this.onFocus,
            "data-test-id": id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default // @ts-ignore DropdownItem doesn't declare support for className
        ), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            id: id,
            href: url ?? undefined,
            testId: (testId || id) ?? undefined,
            onClick: onClick,
            isDisabled: isDisabled,
            elemBefore: elemBefore,
            UNSAFE_shouldDisableRouterLink: true,
            interactionName: interactionName
        }, typeof label === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97c789ddabfb1332$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            gap: "space.075",
            alignItems: "center",
            xcss: $97c789ddabfb1332$var$labelContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            ref: innerRef,
            "data-test-id": "content-item-label",
            dangerouslySetInnerHTML: {
                __html: label.replace(/[0-9]/g, '').replace(/[{()}]/g, '')
            }
        })), label.replace(/\D/g, '').length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $97c789ddabfb1332$var$badgeContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c4sKh.default), null, label.replace(/\D/g, ''))) : null) : label));
        if (shouldHighlight) {
            // COMMENTS-6275: When migration gate is on, use new @atlaskit/spotlight API (PopoverProvider + PopoverTarget).
            // New API has no pulse equivalent; we wrap the target so usage is migrated to @atlaskit/spotlight.
            if ((0, $9wGTI.fg)('confluence_frontend_spotlight_ads_migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingInline: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, contentToolsItem)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                paddingInline: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1lhEF.Pulse), {
                radius: 4
            }, contentToolsItem)));
        }
        return contentToolsItem;
    }
    constructor(...args){
        super(...args);
        $97c789ddabfb1332$var$_defineProperty(this, "onFocus", (event)=>{
            const { onMouseEnter: onMouseEnter } = this.props;
            if (onMouseEnter) onMouseEnter(event);
        });
    }
}
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "propTypes", {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    testId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    url: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node.isRequired,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object,
    linkComponent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).elementType,
    onMouseEnter: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    shouldHighlight: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).elementType
});
$97c789ddabfb1332$var$_defineProperty($97c789ddabfb1332$var$ContentToolsItemClass, "defaultProps", {
    onMouseEnter: ()=>{}
});
const $97c789ddabfb1332$export$c2ed13e36e284c55 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($97c789ddabfb1332$var$ContentToolsItemClass, {
            innerRef: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
});
$97c789ddabfb1332$export$c2ed13e36e284c55.displayName = 'ContentToolsItem';
module.exports["ContentToolsItem"] = $97c789ddabfb1332$export$c2ed13e36e284c55;

});


//# sourceMappingURL=ContentToolsItem.48522e3f.js.map
